export const ORDER_BY_OPTIONS = [`recent-to-past`, `past-to-recent`] as const
export type OrderByOption = (typeof ORDER_BY_OPTIONS)[number]

export const DEFAULT_QUERY_ARGS = {
  page: 1,
  perPage: 25,
  orderBy: ORDER_BY_OPTIONS[0]
}
